export const Classical_Homeopathy = () => {
  return (
    <div className="p-20">
      <h1 className="text-5xl font-bold">Classical Homeopathy</h1>
    </div>
  );
};
